// extracted by mini-css-extract-plugin
export default {"wrapper":"SN_pxC3o","button":"p4Ncha1A","form":"KmKwWcOS","element":"mQpYp_04","search":"lpJ5GQTG"};
    if(module.hot) {
      // 1776432160125
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  